import {
  getIdFromUrl,
} from '@sonifi/wb-core/utils/parseHelper';

export const getBodyServiceIssues = ({ group, node }) => {
  let body = {
    group: group.uri,
    instructions: node.subject.instructions,
    options: node.subject.options.map((op) => {
      if (op.type === 'checkbox') {
        return {
          active: op.active,
          options: op.options,
          title: op.title,
          type: op.type,
          order_identifier_code: op.order_identifier_code,
          vendor_option_id: op.vendor_option_id,
        };
      }
      return {
        active: op.active,
        options: op.options,
        title: op.title,
        type: op.type,
      };
    }),
    title: node.subject.title,
    vendor_issue_id: node.subject.vendor_issue_id,
  };
  if (node.subject.id) {
    body = {
      ...body,
      uri: node.subject.uri,
      id: node.subject.id,
    };
  }
  return body;
};

const buildMenuBodyChildren = ({ children }) => {
  children.forEach((child, index) => {
    delete children[index].indicatorImage;
    delete children[index].secondaryValue;
    delete children[index].placeholder;
    delete children[index].collapsed;

    if (child?.children?.length) {
      buildMenuBodyChildren({ children: child.children });
    }
    children[index] = { ...child, subject: child.subject.uri };
  });

  return children;
};

export const getBodyServiceMenu = ({
  serviceMenu,
}) => {
  const menuChildren = buildMenuBodyChildren({
    children: JSON.parse(JSON.stringify(serviceMenu.menu.children)),
  });

  const menuBody = {
    active: serviceMenu.menu.active,
    children: menuChildren,
    id: serviceMenu.id,
    subject: serviceMenu.menu.subject.uri,
    type: serviceMenu.menu.type,
    valid_child_types: serviceMenu.menu.valid_child_types,
  };

  const bodyServiceMenu = {
    uri: serviceMenu.uri,
    group: serviceMenu.group,
    id: serviceMenu.id,
    title: serviceMenu.title,
    menu: menuBody,
  };
  return bodyServiceMenu;
};

export const getThumbnailBody = ({ node }) => {
  const lastSlashIndex = node.subject.image[0].file_uri.lastIndexOf('.');
  const format = node.subject.image[0].file_uri.substring(lastSlashIndex + 1).replace('jpeg', 'jpg');
  const thumbnailBody = {
    image_url: node.subject.image[0].file_uri,
    position: { width: 180, height: 333, anchor: [node.subject.image[0].x, node.subject.image[0].y] },
    scale: node.subject.image[0].transform.scale,
    format,
    flip: node.subject.image[0].transform.flip,
  };
  return thumbnailBody;
};

export const getServiceCategoryBody = ({ node, groupUri, imageUrl }) => {
  let imageBody = null;
  if (imageUrl) {
    imageBody = {
      aspect_ratio: node.subject.image[0].aspect_ratio || '20:37',
      image: node.subject.image[0].image,
      x: node.subject.image[0].x,
      y: node.subject.image[0].y,
      display_uri: imageUrl,
      transform: node.subject.image[0].transform,
    };
  }

  const serviceCategoriesBody = {
    uri: node.subject.uri,
    group: groupUri,
    confirmation_message: node.subject.confirmation_message,
    description: node.subject.description,
    disclaimer: node.subject.disclaimer,
    email_addresses: node.subject.email_addresses,
    id: node.subject.id,
    image: imageBody ? [imageBody] : undefined,
    title: node.subject.title,
  };

  return serviceCategoriesBody;
};

export const buildImagesParam = (imgData) => {
  const imgIds = [];
  Object.values(imgData).forEach((value) => {
    if (value?.image?.length) {
      value.image.forEach(({ image }) => {
        const imageId = getIdFromUrl({ url: image, parseToInt: false });
        imgIds.push(imageId);
      });
    }
  });
  return imgIds.join(',');
};
